import { FieldPath, UseFormReturn } from "react-hook-form";

import { OptionalLabel } from "@/components/OptionalLabel";
import { StarRatingInput } from "@/components/StarRatingInput";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";

import { cn } from "@/lib/utils";

export const FormStarRatingInput = <T extends Record<string, unknown>>({
  className,
  fieldName,
  form,
  label,
  optional,
}: {
  className?: string;
  fieldName: FieldPath<T>;
  form: UseFormReturn<T>;
  label?: string;
  optional?: boolean;
}) => {
  return (
    <FormField
      control={form.control}
      name={fieldName}
      render={({ field }) => (
        <FormItem className={cn("text-slate-700", className)}>
          {label && (
            <FormLabel>
              {label}
              {optional && <OptionalLabel className="ml-1.5" />}
            </FormLabel>
          )}
          <FormControl>
            <StarRatingInput
              onChange={field.onChange}
              value={Number(field.value) || 0}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
